<template>
    <div>
        <page-navigate></page-navigate>
        <div class="agentServiceHead flex">
            <div class="agentServiceHeadMain">
                <h1 class="super_large-72_bold md-title-32_bold word1">机构服务</h1>
                <h2 class="subtitle-20_regular md-body-14_regular word2">EBC提供一站式接入全球顶级流动性及定制化解决方案，助力机构投资者获得最佳执行条件</h2>
                <a :href="signupUrl" class="primary-default_large">
                    <span class="word3">立即开户</span>
                    <span class="iconfont icon-right"></span>
                </a>
            </div>
            <img src="@/assets/image/service/agencyModel.png" alt="">
        </div>
        <div class="liquidityDepth">
            <div class="contentBox">
                <h2 class="title-48_bold md-title-24_bold text-center scroll-fade-up word4">机构级流动性深度</h2>
                <h3
                    class="liquidityDepthDesc subtitle-20_regular md-footnote-regular_12 text-center scroll-fade-up word5">
                    多层级报价深度，以清晰的报价和交易量，帮助投资者洞悉市场流动性，确保交易透明可靠</h3>
            </div>
            <div class="floatTab flex justify-center items-center scroll-fade-up">
                <div class="tabItem text-center cursor-pointer body-16_regular active word1">
                    衍生品
                </div>
                <div class="tabItem text-center cursor-pointer body-16_regular word2">
                    贵金属及能源
                </div>
                <div class="tabItem text-center cursor-pointer body-16_regular word3">
                    全球股指
                </div>
                <div class="tabItem text-center cursor-pointer body-16_regular word4">
                    美国股票
                </div>
                <div class="tabItem text-center cursor-pointer body-16_regular word4">
                    ETF
                </div>
                <!-- <div class="tabItem text-center cursor-pointer body-16_regular word4">
                    数字资产
                </div> -->
            </div>
            <div class="mobile scrollTabWrapper scroll-fade-up">
                <div class="scrollTab flex justify-center items-center">
                    <div class="tabItem text-center cursor-pointer md-footnote-regular_12 active word1">
                        衍生品
                    </div>
                    <div class="tabItem text-center cursor-pointer md-footnote-regular_12 word2">
                        贵金属及能源
                    </div>
                    <div class="tabItem text-center cursor-pointer md-footnote-regular_12 word3">
                        全球股指
                    </div>
                    <div class="tabItem text-center cursor-pointer md-footnote-regular_12 word4">
                        美国股票
                    </div>
                     <div class="tabItem text-center cursor-pointer  md-footnote-regular_12 word4">
                    ETF
                </div>
                <!-- <div class="tabItem text-center cursor-pointer md-footnote-regular_12 word4">
                    数字资产
                </div> -->
                </div>
            </div>
            <div class="contentBox">
                  <div id="pageOverLay"></div>
                <product-module-new />
                <a :href="signupUrl" class="primary-default_large liquidityDepthBtn scroll-fade-up word6">开始交易</a>
            </div>

        </div>
        <div class="calcSystem">
            <div class="contentBox">
                <h2 class="title-48_bold md-title-24_bold scroll-fade-up word7">清算系统</h2>
                <h3 class=" calcSystemDesc subtitle-20_regular scroll-fade-up word8">集成先进的流动性管理与 AI
                    算法，为机构提供无缝清算服务，确保资金处理安全高效</h3>
                <div class="calcSystemImg scroll-fade-up">
                    <img src="@/assets/image/service/calcSystemModel.png" alt="">
                </div>
                <div class="fake-scrollbar mobile scroll-fade-up">
                    <div class="fake-thumb"></div>
                </div>
            </div>

        </div>
        <div class="EBCTradeSpace">
            <div class="contentBox">
                <h2 class="title-48_bold md-title-24_bold scroll-fade-up word9">EBC 交易空间</h2>
                <h3 class="EBCTradeSpaceDesc subtitle-20_regular scroll-fade-up ">
                    <span class="word10">“清算不是统一的标准，而是适合所有情况的所有答案” </span>
                    <br>
                    <span class="word11">如果您是一位“大交易家”，EBC交易空间，将搭建专属的交易通道，在流动性匹配基础上让你在成交过程中免于狙击</span>
                </h3>
                <div class="tradeSpaceModel scroll-fade-up">
                    <img src="@/assets/image/service/ebcTradeSpace.png" alt="" class="pc">
                    <img src="@/assets/image/service/ebcTradeSpaceM.png" alt="" class="mobile">
                    <div
                        class="tradeSpaceModelWord tradeSpaceModelWord1 content-14_regular md-footnote-regular_12 word12">
                        显示交易信息</div>
                    <div
                        class="tradeSpaceModelWord tradeSpaceModelWord2 content-14_regular md-footnote-regular_12 word13">
                        隐藏部分交易信息</div>
                </div>
                <a :href="signupUrl" class="primary-default_large scroll-fade-up word3" target="_blank">立即开户</a>
            </div>
        </div>
        <message-v3></message-v3>
        <page-footer></page-footer>
    </div>
</template>

<script>
import fadeAnimate from "../mixins/fadeAnimate.js";
import { mapGetters } from "vuex";

export default {
    mixins: [fadeAnimate],
     mounted() {
        document.querySelectorAll(`.message-new p`).forEach((i) => (i.innerHTML = "全球最佳券商<br/>成就赢家之旅"));
        setTimeout(() => {
            this.initPage();
        })
    },
    computed: {
        ...mapGetters(["signupUrl"]),
    },
    methods: {
        initPage() {
            function imageSyncFakeScroll(wrapperSel) {
                const wrap = document.querySelector(wrapperSel);
                const scroll = wrap.querySelector(".calcSystemImg");
                const track = wrap.querySelector(".fake-scrollbar");
                const thumb = wrap.querySelector(".fake-thumb");

                function sync() {
                    const w = scroll.clientWidth;
                    const sw = scroll.scrollWidth;
                    const l = scroll.scrollLeft;
                    const maxL = sw - w;
                    if (maxL <= 0) {
                        thumb.style.width = "100%";
                        return;
                    }

                    const thumbW = (w / sw) * track.clientWidth;
                    thumb.style.width = thumbW + "px";
                    const maxMove = track.clientWidth - thumbW;
                    thumb.style.transform = `translateX(${(l / maxL) * maxMove}px)`;
                    if (l <= 0) {
                        wrap.classList.add("noScroll");
                    } else {
                        wrap.classList.remove("noScroll");
                    }
                }


                scroll.addEventListener("scroll", sync, { passive: true });

                sync();
            }
            // 用法
            imageSyncFakeScroll(".calcSystem");

            document.querySelector('.floatTab').classList.add('scroll-fade-up')
            document.querySelector('.scrollTabWrapper').classList.add('scroll-fade-up')

            const setTabActIdx = (idx, e) => {
                scrollTabElement.forEach((item, index) => {
                    item.classList.remove("active");
                })
                floatTabElement.forEach((item, index) => {
                    item.classList.remove("active");
                })
                floatTabElement[idx].classList.add("active");
                scrollTabElement[idx].classList.add("active");
                const rem = parseFloat(
                    getComputedStyle(document.documentElement).fontSize
                );
                const leftPad = 32 * rem;
                const wrapper = document.querySelector(".scrollTabWrapper");
                wrapper.scrollLeft =
                    idx <= 1 ? 0 : e.target.offsetLeft - leftPad;
            };
            const scrollTabElement = document.querySelectorAll('.scrollTabWrapper .tabItem')
            const floatTabElement = document.querySelectorAll('.floatTab .tabItem')
            function scrollToElement(target, options = {}) {
                const element = typeof target === 'string' ? document.querySelector(target) : target;
                if (!element) {
                    console.warn('目标元素不存在');
                    return;
                }

                // 3. 合并默认配置
                const defaultOptions = {
                    behavior: 'smooth', // 平滑滚动
                    block: 'start',     // 垂直方向对齐: start, center, end, nearest
                    inline: 'nearest'   // 水平方向对齐
                };

                // 4. 执行滚动
                element.scrollIntoView({ ...defaultOptions, ...options });
            }
            floatTabElement.forEach((item, idx) => {
                item.addEventListener('click', function (e) {
                    setTabActIdx(idx, e);
                    ProductVM.changeHandle(idx);
                    scrollToElement('.liquidityDepth h2')
                    setTimeout(() => {
                        document.querySelector('.product-table.scroll-fade-up').classList.add('in-view')
                    }, 500);

                })
            })
            scrollTabElement.forEach((item, idx) => {
                item.addEventListener('click', function (e) {
                    setTabActIdx(idx, e);
                    ProductVM.changeHandle(idx);
                    setTimeout(() => {
                        document.querySelector('.product-table.scroll-fade-up').classList.add('in-view')
                    }, 500)

                })
            })
        }
    }
}
</script>

<style lang="scss" scoped>
    .contentBox {
  margin-inline: auto;
  max-width: 1200rem;
}
body.no-scroll {
  overflow: hidden;
}
#pageOverLay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99;
  display: none;
  opacity: 0;
  transition: opacity 0.6s ease;
}
a:hover{
  color: #fff;
}
.agentServiceHead {
  background: var(--ebc-neutral-bg_c);
  height: 560rem;
  align-items: flex-start!important;
}
.agentServiceHead > img {
  height: 560rem;
  width: 773rem;
}

.agentServiceHeadMain {
  padding-top: 160rem;
  margin-left: calc(50vw - 600rem);
  flex: 0 0 588rem;
}
.agentServiceHeadMain h2 {
  margin: 24rem 0 64rem;
  color: var(--ebc-text-secondary);
}

.agentServiceHeadMain a {
  width: fit-content;
  min-width: 180rem;
  box-sizing: border-box;
  gap: 5rem;
}
 .floatTab{
  position: sticky;
  z-index: 98;
  top:128px;
  margin-inline:auto;
  background:var(--ebc-basecolor-white-85);
  border-radius: var(--ebc-corner-radius-full);
  box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.05);
  backdrop-filter: blur(10px);
  padding:4rem;
  gap:8rem;
  width: 792rem;
  height:64rem;
  opacity: 0;
}

 .floatTab .tabItem{
  flex:1;
  color: var(--ebc-text-secondary);
}
 .floatTab .active{
    border-radius: var(--ebc-corner-radius-full);
    background: var(--ebc-neutral-bg_c);
    color:var(--ebc-text-primary);
    display:flex;
    align-items: center;
    justify-content: center;
    height:100%;
    font-weight: 500;
}
@media (min-width: 996px) {
  .ar .agentServiceHeadMain {
  margin-right: calc(50vw - 600rem);
  margin-left: unset;
  }
  .ru .agentServiceHeadMain{
    flex: 0 0 750rem;
    position: relative;
    z-index: 2;
  }
  .ru .agentServiceHeadMain h2{
    max-width: 720rem;
  }
  .ru .agentServiceHead > img{
    margin-left: -182rem;
  }
  .mn .agentServiceHeadMain{
    flex: 0 0 650rem;
    position: relative;
    z-index: 2;
  }
  .mn .agentServiceHead > img{
    margin-left: -62rem;
  }
  .ar .agentServiceHeadMain h1,
  .ru .agentServiceHeadMain h1,
  .ug .agentServiceHeadMain h1,
  .vi .agentServiceHeadMain h1,
  .mn .agentServiceHeadMain h1,
  .pt .agentServiceHeadMain h1{
    font-size: 75rem;
  }
  
  .ar .agentServiceHeadMain,
  .ru .agentServiceHeadMain,
  .ug .agentServiceHeadMain,
  .pt .agentServiceHeadMain,
  .mn .agentServiceHeadMain,
  .en .agentServiceHeadMain,
  .id .agentServiceHeadMain{
    position: relative;
    z-index: 2;
    flex: 0 0 750rem;
  }
  
  .pt .agentServiceHeadMain,
  .th .agentServiceHeadMain,
  .ug .agentServiceHeadMain,
  .mn .agentServiceHeadMain,
  .es .agentServiceHeadMain{
    position: relative;
    z-index: 2;
    flex: 0 0 900rem;
  }
  .es .agentServiceHeadMain h1{
    font-size: 70rem;
  }
  .th .agentServiceHead > img,
  .mn .agentServiceHead > img,
  .ug .agentServiceHead > img,
  .pt .agentServiceHead > img,
  .es .agentServiceHead > img{
    margin-left: -312rem;
  }
  .ar .agentServiceHead > img,
  .ru .agentServiceHead > img,
  .en .agentServiceHead > img,
  .id .agentServiceHead > img{
    margin-left: -162rem;
  }
  

  .th .agentServiceHeadMain h1,
  .ar .agentServiceHeadMain h1,
  .ru .agentServiceHeadMain h1,
  .ug .agentServiceHeadMain h1,
  .pt .agentServiceHeadMain h1,
  .mn .agentServiceHeadMain h1,
  .en .agentServiceHeadMain h1,
  .id .agentServiceHeadMain h1,
  .es .agentServiceHeadMain h1{
    font-size: 72rem;
    line-height: 75rem;
  }
  .ar .agentServiceHeadMain h2,
  .th .agentServiceHeadMain h2,
  .ug .agentServiceHeadMain h2,
  .ru .agentServiceHeadMain h2,
  .mn .agentServiceHeadMain h2,
  .pt .agentServiceHeadMain h2,
  .id .agentServiceHeadMain h2,
  .en .agentServiceHeadMain h2,
  .es .agentServiceHeadMain h2{
    max-width: 700rem;
  }
}
@media (max-width: 996px) {
  .floatTab{
    display:none!important;
  }
   .scrollTab{
    display: inline-flex;
    gap:16rem;
    min-width: fit-content;
  }
  .scrollTabWrapper{
    overflow-x: auto;
    scroll-behavior: smooth;
    padding:16rem 32rem;
    margin-top: 64rem;
    background: var(--ebc-neutral-bg_a);
    position: sticky;
    top:44px;
    z-index:99
  }
  #productModule{
    margin-top: 32rem!important;
  }
    .scrollTabWrapper::-webkit-scrollbar {
    display: none;
  }
   .scrollTab .tabItem{
    color:var(--ebc-text-secondary);
    padding:16rem 32rem;
    flex:1;
    background: var(--ebc-neutral-bg_b);
    border-radius: var(--ebc-corner-radius-full);
    white-space: nowrap;
  }
   .scrollTab .active{
    background:var(--ebc-basecolor-active-500);
    color:var(--ebc-text-primary_white);
    font-weight: 500;
  }
  .contentBox {
    max-width: 100%;
    padding-inline: 32rem;
  }
  .agentServiceHead {
    flex-direction: column;
    height: auto;
    padding-bottom: 80rem;
    overflow: hidden;
    position: relative;
  }
  .agentServiceHeadMain {
    max-width: 100%;
    margin-left: unset;
    text-align: center;
    order: 2;
    padding-inline: 32rem;
    padding-top: 0;
    flex: 1;
    overflow: hidden;
    margin-top: 640rem;
  }
  .agentServiceHeadMain a {
    width: 100%;
  }
  .agentServiceHead > img {
    width: 994rem;
    height: 720rem;
    position: absolute;
    max-width: unset;
    margin-top: -30px;
    left: -140rem;
  }
}

.liquidityDepth{
  padding:120rem 0;
}
.liquidityDepthDesc{
  color: var(--ebc-text-secondary);
  margin: 16rem 0 60rem;
}
.liquidityDepthBtn{
  min-width:180rem;
  width:fit-content;
  margin-top: 60rem;
  margin-inline:auto;
}
@media (max-width: 996px) {
.liquidityDepth{
padding:160rem 0;
}
.liquidityDepthDesc{
  margin: 16rem 0 64rem;
}
.liquidityDepth .liquidityDepthBtn{
  margin-top: 80rem;
  height:80rem;
  font-size: 28rem;
}
}
.calcSystem {
  padding: 120rem 0;
  background: #131313;
  color: #fff;
  text-align: center;
}
.calcSystemDesc {
  margin: 16rem 0 60rem;
  color: var(--ebc-text-secondary_white);
}
.calcSystemImg img {
  width: 100%;
  height: auto;
}
@media (max-width: 996px) {
  .calcSystem {
    padding: 160rem 0;
  }
  .calcSystem .contentBox{
    padding-inline: 0;
  }
  .calcSystem .contentBox h2,
  .calcSystem .contentBox h3{
    padding-inline: 32rem;
  }
  .calcSystem .calcSystemDesc {
    margin-bottom: 80rem;
    font-size: 24rem;
    line-height: 40rem;
  }
  .calcSystemImg {
    max-width: 100%;
    padding-bottom: 50rem;
    overflow: auto;
    position: relative;
    padding-inline: 32rem;
  }
   .calcSystemImg::-webkit-scrollbar{
    display: none;
   }
  .calcSystemImg img {
    height: 482px;
    width: auto;
    max-width: unset;
  }
      /* 伪滚动条容器 */
 .fake-scrollbar {
  height: 4px;
  background: rgba(255, 255, 255, 0.17);
  border-radius: 2px;
  pointer-events: none;     
    margin-inline: 32rem;
}
/* 伪滑块 */
 .fake-thumb {
  height: 100%;
  background: #fff;
  border-radius: 2px;
  width: 0;                            /* js 动态算 */
  transition: width .2s;
}
}

.EBCTradeSpace{
  padding: 120rem 0;
  text-align: center;
}
.EBCTradeSpace .EBCTradeSpaceDesc{
  margin: 16rem 0 60rem;
  color: var(--ebc-text-secondary);
}
.tradeSpaceModel{
  position: relative;
}
.tradeSpaceModel img{
  width: 100%;
  height: auto;
}
.tradeSpaceModelWord{
  color: var(--ebc-basecolor-active-500);
  position: absolute;
}
.tradeSpaceModelWord1{
  top: 108rem;
  right: 850rem;
}
.tradeSpaceModelWord2{
  top: 150rem;
  left: 850rem;
}
.EBCTradeSpace a{
  width: fit-content ;
  min-width: 180rem;
  margin-inline: auto;
  margin-top: 60rem;
}
@media (max-width: 996px) {
  .EBCTradeSpace{
  padding: 160rem 0;
  overflow: hidden;
}
.EBCTradeSpace .EBCTradeSpaceDesc{
  margin: 16rem 0 152rem;
  font-size: 24rem;
  line-height: 40rem;
}
.tradeSpaceModel{
  height: 600rem;
}
.tradeSpaceModel img{
  height: 600rem;
  width: auto;
  max-width: unset;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}

.tradeSpaceModelWord1 {
  top: -36px;
  left: 50%;
  right: unset;
  transform: translateX(-50%);
}
.tradeSpaceModelWord2 {
  bottom: -36px;
  top: unset;
  right: 50%;
  left: unset;
  transform: translateX(50%);

}
.EBCTradeSpace a{
  height: 80rem;
  margin-top: 160rem;
  font-size: 28rem;
  min-width: 165px;
}
}
</style>
